import { useEmoji } from '../context/EmojiContext';
import './SettingsModal.css';

function SettingsModal({ onClose }) {
  const { isEmojified, setEmojified, emojify } = useEmoji();

  return (
    <div className="settings-modal__backdrop" onClick={onClose}>
      <div
        className="settings-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="settings-modal-title"
        onClick={(event) => event.stopPropagation()}
      >
        <header className="settings-modal__header">
          <h2 id="settings-modal-title">{emojify('⚙️', 'Settings')}</h2>
          <button
            type="button"
            className="settings-modal__close"
            onClick={onClose}
            aria-label="Close settings"
          >
            ×
          </button>
        </header>

        <div className="settings-modal__body">
          <div className="settings-modal__row">
            <div className="settings-modal__copy">
              <strong>{emojify('✨', 'Show emojis')}</strong>
              <span>Add emojis to labels and buttons</span>
            </div>
            <button
              type="button"
              className={`settings-toggle${isEmojified ? ' settings-toggle--on' : ''}`}
              role="switch"
              aria-checked={isEmojified}
              aria-label="Show emojis"
              onClick={() => setEmojified(!isEmojified)}
            >
              <span className="settings-toggle__thumb" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SettingsModal;
